import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import ko from 'axe-core/locales/ko.json';

import Head from 'next/head';
import gnbGenerater from '../src/common/services/gnbGenerater';
import { gnbId } from '../src/common/constants';

function MyApp ({ router, Component, pageProps }) {
  const isGnbYn = Array.isArray(router.query?.gnbYn) ? router.query?.gnbYn[0] !== 'N' : router.query?.gnbYn !== 'N';
  const isMobile = isMobilePathContain(router.pathname);

  console.log('isGnbYn :>> ', isGnbYn);
  console.log(`request path(locale)\t:>> ${router.asPath}(${router.locale})`);

  useEffect(async () => {
    const lastPathSegment = (router.pathname || '').split('/').filter(x => !!x).pop();
    await gnbGenerater({ isMobile, pathname: router.pathname, router, isGnbYn });

    // 핫이슈 페이지의 경우 페이지 새로고침시 스크롤 포지션을 유지 안하도록 처리
    if (window.history.scrollRestoration && lastPathSegment === 'hotissue') {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <>
      <Head>
        <meta name='google-site-verification' content='A8FPDPyVe4prPCljbqy_eRyq3iQazgtIMtjwMHz8Em4' />
        <meta name='naver-site-verification' content='84018caf299c313821354bd9aec9f956228dd998' />
        <link href='/favicon.ico' type='image/x-icon' rel='shortcut icon' />
        <script type='text/javascript' src='/scripts/lib/ua-parser.min.js' />
        <script type='text/javascript' src='/scripts/lib/js.cookie.min.js' />
        <script type='text/javascript' src='/scripts/deviceDetector.min.js' />
      </Head>

      <ul id='skip_nav'>
        <li><a href='#header'>헤더 메뉴</a></li>
        <li><a href='#container'>본문컨텐츠</a></li>
        <li><a href='#footer'>풋터 메뉴</a></li>
      </ul>

      <div id='wrap' className={router.pathname.includes('/promotion') ? 'temp_simple_w' : 'sbs_common_wrap'}>
        <div id={gnbId.headerId} className='header_wrap' style={{ display: isGnbYn ? '' : 'none' }} />

        <Component {...pageProps} />

        <div id={gnbId.footerId} className='footer_wrap' style={{ display: isGnbYn ? '' : 'none' }} />
      </div>
    </>
  );
}

function isMobilePathContain (path) {
  const mobilePathIndex = path.split('/').indexOf('m');
  return mobilePathIndex > -1 && mobilePathIndex < 3;
}
export default MyApp;
